import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '@ubud/storage';
import { Config } from '../values/config';
import { User } from '../models/user';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';
import { NacoService } from './naco.service';

@Injectable()
export class NacoExpressService extends NacoService {
    public constructor(
        config: Config,
        router: Router,
        storage: Storage,
        http: HttpClient,
        location: Location,
        @Inject(REQUEST) private request: any,
        @Inject(RESPONSE) private response: any,
    ) {
        super(config, router, storage, http, location);
    }

    public refreshWithSilentAuth(): Observable<User | null> {
        return of(null);
    }

    public getCurrentOrigin(path: string = ''): string {
        return `${this.request.protocol}://${this.request.headers.host}${this.location.prepareExternalUrl(path || '')}`;
    }

    public redirect(url: string): void {
        this.response.redirect(302, url);
        this.response.end();
    }
}
